<template>
  <div>
    <div id="map" style="height: 500px"></div>
    <p v-if="selectedCoords.lat !== null">
      <span class="title">Coords:</span> {{ selectedCoords.lat.toFixed(6) }},
      {{ selectedCoords.lng.toFixed(6) }}
    </p>
    <p v-if="address"><span class="title">Address:</span> {{ address }}</p>
  </div>
</template>
  
  <script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export default {
  name: "MapPicker",
  data() {
    return {
      map: null,
      marker: null,
      selectedCoords: {
        lat: null,
        lng: null,
      },
      address: "",
    };
  },
  mounted() {
    this.fixDefaultIcon();

    this.map = L.map("map").setView([48.3794, 31.1656], 6);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap",
    }).addTo(this.map);

    this.map.on("click", this.onMapClick);
  },
  methods: {
    fixDefaultIcon() {
      delete L.Icon.Default.prototype._getIconUrl;
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: new URL(
          "leaflet/dist/images/marker-icon-2x.png",
          import.meta.url
        ).href,
        iconUrl: new URL("leaflet/dist/images/marker-icon.png", import.meta.url)
          .href,
        shadowUrl: new URL(
          "leaflet/dist/images/marker-shadow.png",
          import.meta.url
        ).href,
      });
    },
    onMapClick(e) {
      const { lat, lng } = e.latlng;
      this.selectedCoords = { lat, lng };

      if (this.marker) {
        this.marker.setLatLng([lat, lng]);
      } else {
        this.marker = L.marker([lat, lng], { draggable: true }).addTo(this.map);
        this.marker.on("dragend", (e) => {
          const pos = e.target.getLatLng();
          this.selectedCoords = { lat: pos.lat, lng: pos.lng };
          this.fetchAddress(pos.lat, pos.lng);
        });
      }

      this.fetchAddress(lat, lng);
    },
    async fetchAddress(lat, lng) {
      const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`;
      try {
        const res = await fetch(url, {
          headers: {
            "User-Agent": "LeafletMapExampleApp",
          },
        });
        const data = await res.json();
        this.address = data.display_name || "Адрес не найден";
        this.$emit("location-selected", {
          lat,
          lng,
          address: this.address,
          city:
            data.address.city ||
            data.address.town ||
            data.address.village ||
            "",
          street: data.address.road || "",
          house: data.address.house_number || "",
          zip: data.address.postcode || "",
        });
        console.log(data);
      } catch (error) {
        console.error("Ошибка при получении адреса:", error);
        this.address = "Ошибка при получении адреса";
      }
    },
  },
};
</script>

  <style scoped>
p,
span {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.8rem;
  font-weight: 300;
  text-align: left;
}

.title {
  font-weight: 500;
}
</style>
  